import axiosInstance from '../config';

/**
 * Requests a launch URL from the backend for SABA platform.
 * @param {string} [gameId] - Optional sub-game ID
 * @returns {Promise<string|null>} - The launch URL, or null if session expired / invalid
 */
export const launchSaba = async (gameId) => {
  const params = gameId ? { gameId } : {};
  const res = await axiosInstance.get('restricted/saba/launch', { params });
  let data = res && res.data;

  // If response body is a JSON string, parse it
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      if (parsed && typeof parsed === 'object') {
        data = parsed;
      }
    } catch (e) {
      // Not JSON, continue treating as plain text
    }
  }

  // If response is an object with { status: true, url: '...' }
  if (data && typeof data === 'object') {
    if (data.url) return data.url;
    if (data.data && data.data.url) return data.data.url;
  }

  // If response is a direct URL string
  if (typeof data === 'string' && data !== 'null' && data.startsWith('http')) {
    return data;
  }

  return null;
};

/**
 * Requests the SABA game catalogue, so the player picks a game here instead of landing on SABA's homepage.
 * The vendor call is signed on the backend - the partner secret never reaches the browser.
 * @param {string} [category] - Optional vendor category ("Slot", "Lottory", ...)
 * @returns {Promise<Array>} - The games SABA will launch, in the vendor's own order
 */
export const fetchSabaGames = async (category) => {
  const params = category ? { category } : {};
  const res = await axiosInstance.get('restricted/saba/games', { params });
  let data = res && res.data;

  // If response body is a JSON string, parse it
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      throw new Error('Game list unavailable');
    }
  }

  // status:false is the backend saying it could not read the catalogue - not an empty catalogue
  if (!data || typeof data !== 'object' || data.status !== true || !Array.isArray(data.list)) {
    throw new Error('Game list unavailable');
  }

  // A game the vendor marks inactive will not launch, so it is not offered
  return data.list.filter((game) => game && game.active !== false);
};
